import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Main from './components/Layout/main';
import { toast, ToastContainer } from 'react-toastify';
import { UserProvider } from "./context/UserContext";
import { TenantProvider } from "./context/TenantContext";
import { UnsavedChangesProvider } from "./context/UnsavedChangesContext";
import { clearAuthToken } from './utils/authUtils';
// Removed the import for PermissionPages due to the error

import './styles/_variables.css';
import './styles/app.css';
import './styles/theme.css';
import './i18n'
import InactivityHandler from './components/Layout/InActivityHandler';
import i18n from './i18n';
import { getUserData } from 'src/utils/getUserInfo';
import { goToDccLogin } from './utils/dccLogin';
import RootErrorBoundary from './components/RootErrorBoundary';
import { clearAppStorage } from './utils/languageStorage';
import socketService from './utils/socketService';

let BASE_URL_DCC = process.env.REACT_APP_URL_DCC; 

export async function loadConfig() {
  // .env is used directly; no encrypted config to load.
}

// Load config on component initialization
loadConfig().then(() => {
});

const AppContent = () => {
    const location = useLocation();
    const [dccLink, setDccLink] = useState<any>(BASE_URL_DCC); // State for DCC URL
    useEffect(() => {
        loadConfig().then(() => {
          setDccLink(BASE_URL_DCC);
        });
      }, []);
    // The route-change session check that used to live here is gone on purpose. It called
    // getUserData() and redirected to the DCC login whenever it resolved null — but that
    // resolution takes two requests (/csrf/token then /auth/me), by which time the layout
    // chrome had already painted. That is the "page opened, then went to login" flash.
    // Main's app-level gate now answers the same question ABOVE the chrome and renders
    // <NotAuthorized /> instead, so there is exactly one decision and one screen.
    // See components/Layout/main.tsx.

      // Force-logout socket, for a page load with a session already open (login.tsx connects
      // it after a fresh sign-in). This used to be a second socket of its own, beside
      // socketService's, that reconnected every 5s forever - even after a force-logout.
      useEffect(() => {
        getUserData().then((user) => {
          if (!user?.id) return;
          socketService.connect(String(user.id), () => {
            clearAppStorage();
            clearAuthToken();
            toast("user logged out successfully", { type: "success" });
            goToDccLogin('logged_out_elsewhere');
          });
        });
      }, []);

    return <Main />;
};
document.documentElement.lang = i18n.language;
document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';

function App() {
    return (
        // Outermost so it also catches a throw from the providers themselves — one of those
        // failing used to blank the entire app with nothing on screen to explain it.
        <RootErrorBoundary>
            <UserProvider>
                <TenantProvider>
                    <UnsavedChangesProvider>
                        <Router basename={process.env.PUBLIC_URL}>
                            <ToastContainer autoClose={5000} hideProgressBar />
                            <AppContent />
                            <InactivityHandler/>
                        </Router>
                    </UnsavedChangesProvider>
                </TenantProvider>
            </UserProvider>
        </RootErrorBoundary>
    );
}

export default App;
